import MoveToFolderMenuStore from './schema/MoveToFolderMenuStore';
import { createStore } from 'satcheljs';

export const initialStore: MoveToFolderMenuStore = {
    findText: '',
    isFocusInSearchBox: false,
    newFolderViewState: null,
    shouldShowAllFolders: false,
    moveToMailboxContext: 'primary',
    moveToSharedFolderRootId: null,
};

export const getStore = createStore<MoveToFolderMenuStore>('moveToStore', { ...initialStore });

const moveToStore = getStore();
export default moveToStore;
